import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'

import ImagesSlider from '../ui/ImagesSlider'

import Box from '@material-ui/core/Box'
import Markdown from '../ui/Markdown'
import Button from '../ui/Button'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Fade from 'react-reveal/Fade';

const styles = theme => ({
    item: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    //    padding: theme.spacing(0, 3),
    },    
    imageCenter:{
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap'
    },
    imageCard:{
      maxHeight:'100%',
      // maxWidth:'100%',
      objectFit: 'contain'
    },
    relativePosition:{
        position: 'relative'
    },
    imageRight:{
        position: 'absolute',
        left: '-20%',
        width: '120%'
    },
    imageLeft:{
        position: 'absolute',
        width: '120%'
    },
    cardText:{
      zIndex: 1,
      height: '75vh'
    },
    detailCard:{
      padding: '10%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      zIndex: 1,
      background: '#f0f0f0',
    },
    boxItem:{
      display:'flex',
      flexDirection:'row',
      alignItems:'center',
      justifyContent:'center',
      [theme.breakpoints.down('xs')]:{
        flexDirection: 'column-reverse'
      }
    },
    boxItemLeft:{
      display:'flex',
      flexDirection:'row',
      alignItems:'center',
      justifyContent:'center',
      [theme.breakpoints.down('xs')]:{
        flexDirection: 'column'
      }
    },
    boxCollage:{
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingBottom: '5%',
      position:'relative',
      [theme.breakpoints.down('xs')]:{
        width: '100%'
      }
    }
})

const Collage = (props) => {

  const {openLink} = props
  const {classes, title, theme, subtitle,body, images, color, variant, image_width, item_spacing, image_position, positionImage, image_alternate_position, item_size, text_alignment, link_to, button_title, button_style} = props

  let imageUrl = null
  if (images && images !== undefined && images.length > 0) {
    imageUrl = images[0].image_url
    if (imageUrl.startsWith("/"))
      imageUrl = "http://178.128.86.10:8000" + imageUrl
  }

  let smUp = useMediaQuery(theme.breakpoints.up('sm'))  

  let imageBox = []
  let imageStyle = []
  let itemSpacing = []
  let detailText = []
  let imageMobileStyle = []

  if(smUp){
    // if(item_spacing){
    //   imageBox['position'] = 'inherit'
    //   imageMobileStyle['width'] = (image_width+item_spacing)+'%' || '125%'
    //   if(positionImage === 'right'){
    //     imageBox['left'] = (item_spacing*-1)+'%'
    //   }
    // }else{
      imageBox['position'] = 'inherit'
      imageMobileStyle['width'] = '125%'
      if(positionImage === 'right'){
        imageBox['left'] = '-25%'
      }
    // }
  }else{
    // if(item_spacing){
    //   imageBox['width'] = (image_width+item_spacing)+'%' || '100%'
    //   if(positionImage === 'right'){
    //     imageBox['margin-left'] = item_spacing+'%'
    //     detailText['margin-top'] = (item_spacing*-1)+'%'
    //   }else{
    //     imageBox['margin-left'] =(item_spacing*-1)+'%'
    //     detailText['margin-top'] = (item_spacing*-1)+'%'
    //   }
    // }else{
      imageBox['width'] = '100%'
      if(positionImage === 'right'){
        imageBox['margin-left'] = '20%'
        detailText['margin-top'] = '-20%'
        detailText['margin-right'] = '10%'
        imageMobileStyle['width'] = '90%'
      }else{
        // imageStyle['margin-left'] = '-20%'
        detailText['margin-top'] = '-20%'
        detailText['margin-left'] = '10%'
        imageMobileStyle['width'] = '90%'
      }
    // }
  }
  // imageStyle['height'] = '150px'

  if(item_size === 'xl'){
    if(positionImage === 'left'){
      return (
        <Fade>
        <Box className={classes.boxItemLeft}>
          <Box className={classes.boxCollage}>
              { imageUrl &&
              <Box style={imageBox}>
                <img src={imageUrl} className={classes.imageCard} style={imageMobileStyle}/>
              </Box>
              }
          </Box>
          <Box className={classes.boxCollage}>
              <Box className={classes.detailCard} style={detailText}>
                <Markdown source={ title } color={color} theme={theme}/>
                <Markdown source={ subtitle } color={color} theme={theme}/>
                <Markdown source={ body } color={color} theme={theme}/>
                
                { link_to && link_to !== undefined &&
                    <Box align="center" mt={4}  >
                      <Button style={button_style} onClick={ () => openLink(link_to) }>
                        { button_title }
                      </Button>
                    </Box>
                }
              </Box>
          </Box>
        </Box>
        </Fade>
      )
    }else{
      return (
        <Fade>
        <Box className={classes.boxItem}>
          <Box className={classes.boxCollage}>
              <Box className={classes.detailCard} style={detailText}>
                <Markdown source={ title } color={color} theme={theme}/>
                <Markdown source={ subtitle } color={color} theme={theme}/>
                <Markdown source={ body } color={color} theme={theme}/>
                
                { link_to && link_to !== undefined &&
                    <Box align="center" mt={4}  >
                      <Button style={button_style} onClick={ () => openLink(link_to) }>
                        { button_title }
                      </Button>
                    </Box>
                }
              </Box>
          </Box>
          <Box className={classes.boxCollage}>
            { imageUrl &&
              <Box style={imageBox}>
                <img src={imageUrl} className={classes.imageCard} style={imageMobileStyle}/>
              </Box>
              } 
          </Box>
        </Box>
        </Fade>
      )
    }
  }else{
    if(image_position === 'right'){
      return (
        <Fade>
        <Box className={classes.boxItem}>
          <Box className={classes.boxCollage}>
              <Box className={classes.detailCard} style={detailText}>
                <Markdown source={ title } color={color} theme={theme}/>
                <Markdown source={ subtitle } color={color} theme={theme}/>
                <Markdown source={ body } color={color} theme={theme}/>
                
                { link_to && link_to !== undefined &&
                    <Box align="center" mt={4}  >
                      <Button style={button_style} onClick={ () => openLink(link_to) }>
                        { button_title }
                      </Button>
                    </Box>
                }
              </Box>
          </Box>
          <Box className={classes.boxCollage}>
            { imageUrl &&
              <Box style={imageBox}>
                <img src={imageUrl} className={classes.imageCard} style={imageMobileStyle}/>
              </Box>
              } 
          </Box>
        </Box>
        </Fade>
      )
    }else if(image_position === 'left'){
      return (
        <Fade>
        <Box className={classes.boxItemLeft}>
          <Box className={classes.boxCollage}>
              { imageUrl &&
              <Box style={imageBox}>
                <img src={imageUrl} className={classes.imageCard} style={imageMobileStyle}/>
              </Box>
              }
          </Box>
          <Box className={classes.boxCollage}>
              <Box className={classes.detailCard} style={detailText}>
                <Markdown source={ title } color={color} theme={theme}/>
                <Markdown source={ subtitle } color={color} theme={theme}/>
                <Markdown source={ body } color={color} theme={theme}/>
                
                { link_to && link_to !== undefined &&
                    <Box align="center" mt={4}  >
                      <Button style={button_style} onClick={ () => openLink(link_to) }>
                        { button_title }
                      </Button>
                    </Box>
                }
              </Box>
          </Box>
        </Box>
        </Fade>
      )
    }else if(image_position === 'top'){
      return (
        ''
      )
    }
  }
}

export default withStyles(styles, { withTheme: true })(Collage);

